import React from 'react';
import { Popup } from "react-leaflet";
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Box, Avatar, Typography, Badge , CardHeader, Button, Tooltip as MaterialTooltip } from '@material-ui/core';
import PhotoIcon from '@material-ui/icons/InsertPhotoRounded';
import PlayCircleIcon from '@material-ui/icons/PlayCircleFilled';
//import ThreeDRotationRoundedIcon from '@material-ui/icons/ThreeDRotationRounded';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { translations } from '../../i18n/i18n';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
	overviewImage: {
		height: '100%',
		maxHeight: '150px',
		marginBottom: theme.spacing(),
		objectFit: 'cover',
		width: '100%',
	},
}));

const PlacePopup = ({ place, placeTypes, placeTypeIcons }) => {
	const history = useHistory();
	const { path, url } = useRouteMatch();
	const classes = useStyles();

	const openPlaceDetails = () => {
		history.push(`/${place.id}-${place.name.toLowerCase().normalize("NFD").replaceAll(' ', '-').replace(/[^a-z0-9\-]/g,'').replaceAll('--', '-')}`);
	};

	return <Popup className="map-popup">
		<CardHeader
			avatar={<Avatar classes={{ root: 'place-avatar' }}>
				<MaterialTooltip title={placeTypes.find(placeType => placeType.id == place.place_type_ids[0]).name} placement="top" arrow>
					<div dangerouslySetInnerHTML={{ __html: placeTypeIcons[place.place_type_ids[0]].options.html }} className="place-avatar-icon"></div>
				</MaterialTooltip>
			</Avatar>}
			title={place.name}
			subheader={place.location || place.alt_name}
		/>
		<Box mx={2}>
			{place.overviewPhoto && 
				<img src={place.overviewPhoto.thumb_url} alt={place.overviewPhoto.caption ?? ''} className={classes.overviewImage} />}
			<Typography variant="body2" color="textSecondary" align="justify" component="div">
				{place.guide_intro}
			</Typography>
		</Box>
		<Box display="flex" alignItems="center" mt={3} mb={2} mx={1}>
			<Box display="flex" justifyContent="space-around" flexGrow={1} mr={10} mt={1}>
				<MaterialTooltip title={`${place.number_of_photos} ${translations.components.placePopup.imagesAvailable}`} placement="top">
					<Badge badgeContent={place.number_of_photos+''} color="secondary" classes={{ badge: 'place-badge' }}>
						<PhotoIcon />
					</Badge>
				</MaterialTooltip>
				<MaterialTooltip title={`${place.number_of_videos} ${translations.components.placePopup.videosAvailable}`} placement="top">
					<Badge badgeContent={place.number_of_videos+''} color="secondary" classes={{ badge: 'place-badge' }}>
						<PlayCircleIcon />
					</Badge>
				</MaterialTooltip>
				{/*<MaterialTooltip title={`${place.number_of_models} rekonstrukció érhető el`} placement="top">
					<Badge badgeContent={place.number_of_models+''} color="secondary" classes={{ badge: 'place-badge' }}>
						<ThreeDRotationRoundedIcon />
					</Badge>
				</MaterialTooltip>*/}
			</Box>
			<Button size="small" color="secondary" endIcon={<ChevronRightIcon color="secondary" />} onClick={openPlaceDetails}>
				{translations.components.placePopup.details}
			</Button>
		</Box>
	</Popup>;
}

export default React.memo(PlacePopup);